import { useContext, useEffect, useState } from 'react'
import { LoginContext } from '../../contexts/login-context'
import { getInitials } from '../../utilities/utils'
import { UserImg, UserIcon } from './header-styles'

const UserImage = () => {
  const { user } = useContext(LoginContext)
  const [userInitials, setUserInitials] = useState('')
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    user && setUserInitials(getInitials(user?.displayName))
  }, [user])

  return imageError
    ? (
    <UserIcon>{userInitials}</UserIcon>
      )
    : (
    <UserImg
      src={user?.photoURL || ''}
      alt={user?.displayName || ''}
      referrerPolicy="no-referrer"
      onError={() => setImageError(true)}
    />
      )
}

export default UserImage
